import { uiStore } from "./uiStore";
import { loggedInUserStore } from "./loggedInUserStore";
import { getCookieValue } from "../modules/common/utils/cookie.utils";
import { User } from "../api/models";

export const useStore = () => {
  const ui = uiStore();
  const user = loggedInUserStore();

  const isLoggingIn = () => {
    const loggedInUser = user.loggedInUser;
    const coreToken = getCookieValue("sn_loggin_user_token");
    return coreToken != null && loggedInUser == null;
  };

  const saveInfo = async (data) => {
    await ui.afterSignIn(data);
    user.setCurrentUser(new User(data.user));
  };

  const printNewsCounter = () => {
    if (ui.newsCounter > 0) {
      return `(${ui.newsCounter})`;
    }

    return "";
  };

  return {
    printNewsCounter,
    ui,
    user,
    saveInfo,
    isLoggingIn,
  };
};
